var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BmIcon',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(ref){
var fillClass = ref.fillClass;
return [_c('rect',{class:fillClass,attrs:{"x":"7","width":"2","height":"16","rx":"1"}}),_c('rect',{class:fillClass,attrs:{"x":"16","y":"7","width":"2","height":"16","rx":"1","transform":"rotate(90 16 7)"}})]}}])},'BmIcon',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }